import { type RangeSliderConfig } from '#types.ts';
import { type MovieFormikValues, type TvFormikValues } from '../types.ts';

export const RANGE_SLIDER_NAMES = ['firstAired', 'certifications', 'releaseYears', 'voteAverages', 'runtimes'];

const inRangeSliderNames = <U extends string>(key: string): key is U => RANGE_SLIDER_NAMES.includes(key);

export const createMovieRangeSlidersConfig = (initialValues: MovieFormikValues) =>
  Object.keys(initialValues).reduce<Record<string, RangeSliderConfig>>((acc, key) => {
    if (!inRangeSliderNames<'certifications' | 'releaseYears' | 'runtimes' | 'voteAverages'>(key)) {
      return acc;
    }

    acc[key] = {
      disabled: initialValues[key].length === 0,
    };

    return acc;
  }, {});

export const createTvRangeSlidersConfig = (initialValues: TvFormikValues) =>
  Object.keys(initialValues).reduce<Record<string, RangeSliderConfig>>((acc, key) => {
    if (!inRangeSliderNames<'firstAired' | 'runtimes' | 'voteAverages'>(key)) {
      return acc;
    }

    acc[key] = {
      disabled: initialValues[key].length === 0,
    };

    return acc;
  }, {});
